import MuiDialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import styled from "styled-components";

/*
  Token colors are fixed per mode instead of derived from the palette: the
  primary/secondary colors are white-label configurable, and a JSON viewer needs
  stable, readable token colors whatever brand colors the deployment uses.
*/
const TOKEN_COLORS = {
  light: {
    key: "#0b5394",
    string: "#0a7b41",
    number: "#a33d0f",
    boolean: "#8250df",
    null: "#6e7781"
  },
  dark: {
    key: "#79c0ff",
    string: "#7ee787",
    number: "#ffa657",
    boolean: "#d2a8ff",
    null: "#8b949e"
  }
};

export const Dialog = styled(MuiDialog)`
  & .MuiDialog-paper {
    width: 800px;
    max-width: 90vw;
  }
`;

export const Content = styled(DialogContent)`
  padding-top: ${({ theme }) => theme.spacing(1)};
`;

export const Json = styled.pre`
  margin: 0;
  padding: ${({ theme }) => theme.spacing(2)};
  max-height: 60vh;
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 4px;
  background: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.grey[900]
      : theme.palette.grey[100]};
  color: ${({ theme }) => theme.palette.text.primary};
  font-family:
    ui-monospace, "SFMono-Regular", "Menlo", "Consolas", "Liberation Mono",
    monospace;
  font-size: 0.8rem;
  line-height: 1.6;
`;

export const JsonKey = styled.span`
  color: ${({ theme }) => TOKEN_COLORS[theme.palette.mode].key};
`;

export const JsonString = styled.span`
  color: ${({ theme }) => TOKEN_COLORS[theme.palette.mode].string};
`;

export const JsonNumber = styled.span`
  color: ${({ theme }) => TOKEN_COLORS[theme.palette.mode].number};
`;

export const JsonBoolean = styled.span`
  color: ${({ theme }) => TOKEN_COLORS[theme.palette.mode].boolean};
`;

export const JsonNull = styled.span`
  color: ${({ theme }) => TOKEN_COLORS[theme.palette.mode].null};
`;
